import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Chip,
    Drawer, FormGroup, FormLabel,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    OutlinedInput,
    Stack,
    Typography,
    useMediaQuery
} from '@mui/material';
import Select from '@mui/material/Select';

import MainCard from '../../../Components/MainCard';
import IconButton from '../../../Components/@extended/IconButton';
import SimpleBarScroll from '../../../Components/third-party/SimpleBar';

// assets
import {
  CheckCircleFilled,
  ClockCircleFilled,
  LogoutOutlined,
  MinusCircleFilled,
  RightOutlined,
  SearchOutlined,
  SettingOutlined
} from '@ant-design/icons';

// third-party
import * as yup from 'yup';
import FormControl from "@mui/material/FormControl";

function ChatDrawerParameter({handleDrawerOpen, openChatDrawer, top_k_select,
                  handleTopKChange,
                  max_length_select,
                  handleMaxLength,
                  top_p_select,
                  handleTopP,
                  temperature_select,
                  handleTemperature,
                  do_sample_select,
                  handleDoSample,
                  language_select,
                  handleLanguage}) {
    const theme = useTheme();
    const drawerBG = 'dark.main';

    return (
        <Drawer
            sx={{
                width: 320,
                flexShrink: 0,
                zIndex: { xs: 1100, lg: 0 },
                '& .MuiDrawer-paper': {
                  height: 'auto',
                  width: 320,
                  boxSizing: 'border-box',
                  position: 'relative',
                  border: 'none'
                }
            }}
            variant='persistent'
            anchor="left"
            open={openChatDrawer}
            ModalProps={{ keepMounted: true }}
            onClose={handleDrawerOpen}
          >
            <MainCard
                sx={{
                    bgcolor: 'transparent',
                    borderRadius: '4px 0 0 4px',
                    borderRight: 'none'
            }}
                border={true}
                content={false}
            >
                <Box sx={{ p: 3, pb: 1 }}>
                    <Stack spacing={2}>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <Typography variant="h5" color="inherit">
                                Tax Bot Parameters
                            </Typography>
                        </Stack>
                    </Stack>
                </Box>
                <SimpleBarScroll
                    sx={{
                        // overflowX: 'hidden',
                        height: 'calc(100vh - 410px)',
                        minHeight: 0
                }}>
                    <Box sx={{ p: 3, pt: 0 }}>
                        <FormControl fullWidth>
                            <FormGroup sx={{padding:2, borderRadius:2, border:'1px solid', borderColor:'primary.main'}}>
                                <FormLabel component="legend">top_k</FormLabel>
                                <Select
                                    labelId="top-k-select-label"
                                    id="top-k-select"
                                    value={top_k_select}
                                    onChange={handleTopKChange}
                                    autoWidth
                                    label="top-k"
                                >
                                    <MenuItem value="">
                                        <em>Select top_k parameter</em>
                                    </MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                </Select>

                                <FormLabel component="legend">max length</FormLabel>
                                <Select
                                    labelId="max-length-select-label"
                                    id="max-length-select"
                                    value={max_length_select}
                                    onChange={handleMaxLength}
                                    autoWidth
                                    label="max-length"
                                >
                                    <MenuItem value="">
                                        <em>Select max length parameter</em>
                                    </MenuItem>
                                    <MenuItem value={1000}>1000</MenuItem>
                                    <MenuItem value={2000}>2000</MenuItem>
                                    <MenuItem value={3000}>3000</MenuItem>
                                    <MenuItem value={4000}>4000</MenuItem>
                                    <MenuItem value={5000}>5000</MenuItem>
                                </Select>

                                <FormLabel component="legend">top_p</FormLabel>
                                <Select
                                    labelId="top-p-select-label"
                                    id="top-p-select"
                                    value={top_p_select}
                                    onChange={handleTopP}
                                    autoWidth
                                    label="top-p"
                                >
                                    <MenuItem value="">
                                        <em>Select top_p parameter</em>
                                    </MenuItem>
                                    <MenuItem value={0.2}>0.2</MenuItem>
                                    <MenuItem value={0.4}>0.4</MenuItem>
                                    <MenuItem value={0.6}>0.6</MenuItem>
                                    <MenuItem value={0.8}>0.8</MenuItem>
                                    <MenuItem value={1.0}>1.0</MenuItem>
                                </Select>

                                <FormLabel component="legend">temperature</FormLabel>
                                <Select
                                    labelId="temperature-select-label"
                                    id="temperature-select"
                                    value={temperature_select}
                                    onChange={handleTemperature}
                                    autoWidth
                                    label="temperature"
                                >
                                    <MenuItem value="">
                                        <em>Select temperature parameter</em>
                                    </MenuItem>
                                    <MenuItem value={0.2}>0.2</MenuItem>
                                    <MenuItem value={0.4}>0.4</MenuItem>
                                    <MenuItem value={0.6}>0.6</MenuItem>
                                    <MenuItem value={0.8}>0.8</MenuItem>
                                    <MenuItem value={1.0}>1.0</MenuItem>
                                </Select>

                                <FormLabel component="legend">do_sample</FormLabel>
                                <Select
                                    labelId="do-sample-select-label"
                                    id="do-sample-select"
                                    value={do_sample_select}
                                    onChange={handleDoSample}
                                    autoWidth
                                    label="do-sample"
                                >
                                    <MenuItem value="">
                                        <em>Select do_sample parameter</em>
                                    </MenuItem>
                                    <MenuItem value="True">True</MenuItem>
                                    <MenuItem value="False">False</MenuItem>
                                </Select>

                                <FormLabel component="legend">language</FormLabel>
                                <Select
                                    labelId="language-select-label"
                                    id="language-select"
                                    value={language_select}
                                    onChange={handleLanguage}
                                    autoWidth
                                    label="language-select"
                                >
                                    <MenuItem value="">
                                        <em>Select language</em>
                                    </MenuItem>
                                    <MenuItem value="English">English</MenuItem>
                                    <MenuItem value="Bahasa Indonesia">Bahasa Indonesia</MenuItem>
                                </Select>

                            </FormGroup>
                        </FormControl>
                    </Box>
                </SimpleBarScroll>
            </MainCard>
        </Drawer>

    )

}

ChatDrawerParameter.propTypes = {
    handleDrawerOpen: PropTypes.func,
    openChatDrawer: PropTypes.bool
}

export default ChatDrawerParameter;